import { createPaginatedSlice } from '../../../helpers/reduxHelper';
const perPage = 20
const paginatedTeam = createPaginatedSlice('paginatedTeam', { defaultState: { perPage: perPage } });

export const paginatedTeamActions = paginatedTeam.actions;
export const paginatedTeamSelector = (state) => state.paginatedTeam;
export const paginatedTeamReducer = paginatedTeam.reducer;
export default paginatedTeamReducer;
